import React, { Component } from 'react'
import styles from './styles/pageTitle.module.scss'

class PageTitle extends Component {
	render() {
		const { title } = this.props
		return (
			<div className={styles.titleContainer}>
				<h1 className={styles.title}>{title}</h1>
			</div>
		)
	}
}

export { PageTitle }



// WEBPACK FOOTER //
// ./src/components/common/PageTitle.js